"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compact = exports.LayoutMode = void 0;
var _reactGridLayout = require("react-grid-layout");
// @ts-expect-error utils export is missing from types

const LayoutMode = exports.LayoutMode = {
  GRID: {
    id: 'GRID',
    name: 'Grid view',
    icon: 'grid-view'
  },
  LIST: {
    id: 'LIST',
    name: 'Stacked view',
    icon: 'list'
  }
};
Object.defineProperties(LayoutMode, {
  DEFAULT: {
    enumerable: false,
    get() {
      return this.GRID;
    }
  }
});

/**
 * utils are missing from react-grid-layout types, so we re-export the ones we need with proper types
 * this won't be needed when we upgrade to react-grid-layout v2
 */

const compact = exports.compact = _reactGridLayout.utils.compact;